export default __webpack_public_path__ + "static/media/1-mini.a056cee4.webp";